<template>
<div class="mct-successor-add" v-once>
<!-- start page title -->
<div class="row">
    <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
            <h4 class="mb-sm-0">เพิ่มผู้มีสิทธิ (ทายาท)</h4>
            <div class="page-title-right">
                <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">จัดการสมาชิกนักแต่ง</a></li>
                    <li class="breadcrumb-item active">เพิ่มผู้มีสิทธิ (ทายาท)</li>
                </ol>
            </div>
        </div>
    </div>
</div>
<!-- end page title -->

<div class="card">
    <div class="card-header bg-info-subtle border-0">
        <h4 class="card-title mb-0">ข้อมูลสมาชิกนักแต่งเพลงที่อ้างอิง</h4>
    </div>
    <div class="card-body">
        <div class="row g-3">
            <div class="col-xl-4">
                <label class="form-label" for="source-member-code-view">รหัสสมาชิก</label>
                <input type="text" id="source-member-code-view" class="form-control bg-light" :value="sourceMemberCode" readonly>
            </div>
            <div class="col-xl-5">
                <label class="form-label" for="source-member-name-view">ชื่อสมาชิกนักแต่งเพลง</label>
                <input type="text" id="source-member-name-view" class="form-control bg-light" :value="sourceMemberName" readonly>
            </div>
            <div class="col-xl-3">
                <label class="form-label" for="source-writer-type-view">ประเภทนักแต่ง</label>
                <input type="text" id="source-writer-type-view" class="form-control bg-light" :value="sourceWriterType" readonly>
            </div>
        </div>
    </div>
</div>

<div id="member-add-alert">
    <div v-if="flashMessage" :class="'alert alert-' + flashKind + ' alert-dismissible fade show'" role="alert">
        {{ flashMessage }}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="ปิด"></button>
    </div>
</div>

<form id="form-member-add" method="post" :action="createUrl" autocomplete="off" novalidate>
    <input type="hidden" name="name_type" value="SP">
    <input type="hidden" name="form_origin" value="successor">
    <input type="hidden" name="source_member_code" :value="sourceMemberCode">
    <input type="hidden" name="source_member_name" :value="sourceMemberName">
    <input type="hidden" name="source_writer_type" :value="sourceWriterType">
    <div class="card">
        <div class="card-header bg-primary text-white border-0 d-flex flex-wrap align-items-center justify-content-between gap-2">
            <h4 class="card-title mb-0 text-white">ข้อมูลผู้มีสิทธิ (ทายาท)</h4>
            <span class="small text-white-50"><span class="text-warning">*</span> <span class="text-danger fw-bold mct-req-hint mct-req-hint-legend d-none">จำเป็นต้องกรอก</span></span>
        </div>
        <div class="card-body">
            <div class="row g-3">
                <div class="col-lg-3">
                    <label class="form-label" for="member-code">รหัสจัดการผู้มีสิทธิ (ทายาท) <span class="text-danger">*</span></label>
                    <input type="text" class="form-control bg-light" id="member-code" name="member_code" maxlength="64" required readonly inputmode="text" :value="autoMemberCode" placeholder="SUCYYMM + ลำดับ 4 หลัก (สร้างอัตโนมัติ)" title="รูปแบบ SUCYYMM#### — สร้างอัตโนมัติต่อเดือนสำหรับผู้มีสิทธิ (ทายาท)">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    <small class="text-muted d-block">รหัสจัดการผู้มีสิทธิ (ทายาท) สร้างอัตโนมัติ</small>
                </div>
                <div class="col-lg-3">
                    <label class="form-label" for="internal-no-mis">Internal No. <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="internal-no-mis" name="internal_no_mis" maxlength="64" required inputmode="numeric" autocomplete="off" pattern="[0-9]*" placeholder="503660" title="ใส่ได้เฉพาะตัวเลข ไม่มีช่องว่างหรือขีด">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-3">
                    <label class="form-label" for="ipi-name-no">IPI Name No. <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="ipi-name-no" name="ipi_name_no" maxlength="64" required inputmode="numeric" autocomplete="off" pattern="[0-9]*" placeholder="00216126011" title="ใส่ได้เฉพาะตัวเลข ไม่มีช่องว่างหรือขีด">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-3">
                    <label class="form-label" for="ipi-base-no">IPI Base No. <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="ipi-base-no" name="ipi_base_no" maxlength="64" required autocomplete="off" pattern="^I-[0-9]{9}-[0-9]$" placeholder="I-000511005-2" title="รูปแบบ I-XXXXXXXXX-Y (เลข 9 หลักระหว่างขีด) — ต้องไม่ซ้ำในฐานข้อมูล">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <input type="hidden" name="writer_type" value="General Member">
                <input type="hidden" name="rightsholder_type" value="ทายาท">
                <div class="col-lg-3">
                    <label class="form-label" for="member-status">สถานะ</label>
                    <select id="member-status" name="status" class="form-select" aria-label="สถานะสมาชิก" title="สถานะในฐานข้อมูล">
                        <option value="active" selected>ใช้งาน</option>
                        <option value="inactive">ไม่ใช้งาน</option>
                        <option value="suspended">ระงับ</option>
                        <option value="resigned">ลาออก</option>
                        <option value="deceased">เสียชีวิต</option>
                    </select>
                    <small class="form-text text-muted mb-0">ค่าเริ่มต้น active — เปลี่ยนได้ตามต้องการ</small>
                    <input type="hidden" name="created_source" value="manual_add">
                </div>
                <div class="col-12" id="composer-creative-roles-wrap" style="display:none;" aria-live="polite">
                    <div class="border rounded p-3 bg-light">
                        <label class="form-label fw-semibold mb-2">บทบาทผู้สร้างสรรค์เพลง</label>
                        <div class="d-flex flex-column gap-2">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="creative-role-melody" name="creative_role_melody" value="1">
                                <label class="form-check-label" for="creative-role-melody">ผู้ประพันธ์ทำนอง</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="creative-role-lyrics" name="creative_role_lyrics" value="1">
                                <label class="form-check-label" for="creative-role-lyrics">ผู้ประพันธ์เนื้อร้อง</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="creative-role-arrangement" name="creative_role_arrangement" value="1">
                                <label class="form-check-label" for="creative-role-arrangement">ผู้เรียบเรียงเสียงประสาน</label>
                            </div>
                        </div>
                        <small class="form-text text-muted mb-0">ไม่บังคับ — เลือกตามความเป็นจริง</small>
                    </div>
                </div>
                <div class="col-12" id="composer-publisher-affiliation-wrap" style="display:none;" aria-live="polite">
                    <label class="form-label" for="affiliated-publisher-live-search">สังกัดค่ายหรือบริษัทผู้พิมพ์ผู้โฆษณา (Publisher)</label>
                    <p class="text-muted small mb-2">ค้นหาจากสมาชิกที่ลงทะเบียนเป็นประเภท Publisher ในระบบ — เลือกรายการแล้วแก้ไขชื่อในช่องด้านล่างได้</p>
                    <div class="position-relative mb-2">
                        <input type="text" class="form-control" id="affiliated-publisher-live-search" autocomplete="off" placeholder="พิมพ์ชื่อค่าย รหัสสมาชิก หรือ IPI (อย่างน้อย 2 ตัวอักษร)" aria-autocomplete="list" aria-controls="affiliated-publisher-dropdown" disabled>
                        <div id="affiliated-publisher-dropdown" class="list-group position-absolute w-100 mt-1 shadow-sm border rounded" role="listbox" style="z-index:1050;max-height:260px;overflow-y:auto;display:none;top:100%;left:0;"></div>
                    </div>
                    <label class="form-label" for="composer-publisher-affiliation">ชื่อสังกัดที่บันทึก <span class="text-danger composer-affil-req d-none">*</span></label>
                    <input type="text" class="form-control" id="composer-publisher-affiliation" name="affiliated_publisher" maxlength="255" placeholder="เลือกจากการค้นหาด้านบน หรือพิมพ์ชื่อเอง" disabled autocomplete="organization">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint composer-affil-req-hint d-none">จำเป็นต้องกรอก</small>
                    <input type="hidden" id="affiliated-publisher-member-id" name="affiliated_publisher_member_id" value="" disabled>
                    <div id="affiliated-publisher-status" class="text-muted small mt-1"></div>
                    <small class="text-muted">แสดงเมื่อเลือกประเภทผู้ทรงสิทธิ &quot;นักแต่งเพลง&quot;</small>
                </div>
            </div>
        </div>
    </div>

    <div class="card" id="personal-info-card">
        <div class="card-header bg-primary text-white border-0">
            <h4 class="card-title mb-0 text-white">
                <span id="personal-card-heading-person">ข้อมูลส่วนบุคคล</span>
                <span id="personal-card-heading-org" class="d-none">ข้อมูลบริษัทหรือองค์กร</span>
            </h4>
            <p id="personal-card-desc-person" class="small text-white-50 mb-0 mt-1">ข้อมูลนี้จะบันทึกในตาราง <code class="text-warning px-1 rounded bg-dark bg-opacity-25">personal_info</code> หลังสร้างสมาชิกแล้ว (เชื่อมด้วย <code class="text-warning px-1 rounded bg-dark bg-opacity-25">member_id</code>)</p>
            <p id="personal-card-desc-org" class="small text-white-50 mb-0 mt-1 d-none">ข้อมูลนิติบุคคล — ใช้คอลัมน์เดียวกับบุคคลใน <code class="text-warning px-1 rounded bg-dark bg-opacity-25">personal_info</code> (ชื่อองค์กร→ชื่อ, เลขผู้เสียภาษี→เลขบัตรฯ ฯลฯ) เพื่อให้บันทึกได้ก่อนขยายสคีมา</p>
        </div>
        <div class="card-body">
            <div id="personal-info-person-wrap" class="row g-3">
                <div class="col-lg-2 col-md-6">
                    <label class="form-label" for="title">คำนำหน้า <span class="text-danger">*</span></label>
                    <select id="title" name="title" class="form-select" required aria-label="คำนำหน้า" title="เลือกคำนำหน้า">
                        <option value="">— เลือก —</option>
                        <option value="นาย">นาย</option>
                        <option value="นาง">นาง</option>
                        <option value="นางสาว">นางสาว</option>
                        <option value="เด็กชาย">เด็กชาย</option>
                        <option value="เด็กหญิง">เด็กหญิง</option>
                        <option value="ดร.">ดร.</option>
                        <option value="ศ.ดร.">ศ.ดร.</option>
                        <option value="ศาสตราจารย์">ศาสตราจารย์</option>
                        <option value="รศ.ดร.">รศ.ดร.</option>
                        <option value="ผศ.ดร.">ผศ.ดร.</option>
                    </select>
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-5 col-md-6">
                    <label class="form-label" for="first-name-local">ชื่อ (ภาษาไทย) <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="first-name-local" name="first_name_local" maxlength="200" required placeholder="กรอกชื่อภาษาไทย">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-5 col-md-6">
                    <label class="form-label" for="last-name-local">นามสกุล (ภาษาไทย) <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="last-name-local" name="last_name_local" maxlength="200" required placeholder="กรอกนามสกุลภาษาไทย">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-6 col-md-6">
                    <label class="form-label" for="first-name-eng">ชื่อ (English) <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="first-name-eng" name="first_name_eng" maxlength="200" required placeholder="First name">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-6 col-md-6">
                    <label class="form-label" for="last-name-eng">นามสกุล (English) <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="last-name-eng" name="last_name_eng" maxlength="200" required placeholder="Last name">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="id-card-number">เลขบัตรประชาชน <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="id-card-number" name="id_card_number" maxlength="17" required inputmode="numeric" pattern="[0-9]-[0-9]{4}-[0-9]{5}-[0-9]{2}-[0-9]" placeholder="เช่น 1-1014-00785-27-9" title="รูปแบบ 1-1014-00785-27-9 (ตัวเลขรวม 13 หลัก)">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="birth-date">วันเกิด <span class="text-danger">*</span></label>
                    <input type="date" class="form-control" id="birth-date" name="birth_date" required title="คลิกเพื่อเลือกวันเดือนปีเกิด (ค.ศ.)">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-4">
                    <label class="form-label" for="nationality">สัญชาติ <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="nationality" name="nationality" maxlength="100" required placeholder="เช่น ไทย">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
            </div>

            <div id="personal-info-org-wrap" class="row g-3 d-none" aria-live="polite">
                <div class="col-12">
                    <label class="form-label" for="org-name-local">ชื่อองค์กร / บริษัท (ภาษาไทย) <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="org-name-local" name="first_name_local" maxlength="200" required placeholder="ชื่อจดทะเบียนภาษาไทย" disabled autocomplete="organization">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-6 col-md-6">
                    <label class="form-label" for="org-branch-local">ชื่อสาขา / คำอธิบายเพิ่มเติม (ไทย)</label>
                    <input type="text" class="form-control" id="org-branch-local" name="last_name_local" maxlength="200" placeholder="ถ้ามี เช่น สำนักงานใหญ่, สาขา..." disabled>
                    <small class="form-text text-muted mb-0">ไม่บังคับ</small>
                </div>
                <div class="col-lg-6 col-md-6">
                    <label class="form-label" for="org-name-eng">ชื่อองค์กร (English) <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="org-name-eng" name="first_name_eng" maxlength="200" required placeholder="Registered name in English" disabled>
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-12 col-lg-6">
                    <label class="form-label" for="org-trade-name-eng">ชื่อทางการค้า / Trading name (English)</label>
                    <input type="text" class="form-control" id="org-trade-name-eng" name="last_name_eng" maxlength="200" placeholder="ถ้ามี" disabled>
                    <small class="form-text text-muted mb-0">ไม่บังคับ</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="org-tax-id">เลขประจำตัวผู้เสียภาษี <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="org-tax-id" name="id_card_number" maxlength="13" required inputmode="numeric" pattern="[0-9]{1,13}" placeholder="ไม่เกิน 13 หลัก" disabled>
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="org-established-date">วันจดทะเบียน / วันก่อตั้ง <span class="text-danger">*</span></label>
                    <input type="date" class="form-control" id="org-established-date" name="birth_date" required title="วันจดทะเบียนหรือวันก่อตั้ง (ค.ศ.)" disabled>
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="org-country">ประเทศที่จดทะเบียน</label>
                    <input type="text" class="form-control" id="org-country" name="nationality" maxlength="100" placeholder="เช่น ประเทศไทย" disabled>
                    <small class="form-text text-muted mb-0">ไม่บังคับ</small>
                </div>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-header bg-primary text-white border-0">
            <h4 class="card-title mb-0 text-white">ข้อมูลติดต่อ</h4>
            <p class="small text-white-50 mb-0 mt-1">อีเมล เบอร์โทร (รูปแบบ 00 000 0000) + ต่อ <code class="text-warning px-1 rounded bg-dark bg-opacity-25">contact_phone_ext[]</code> และมือถือ (000 000 0000) — แถวเพิ่มได้ (<code class="text-warning px-1 rounded bg-dark bg-opacity-25">contact_email[]</code>, <code class="text-warning px-1 rounded bg-dark bg-opacity-25">contact_phone[]</code>, <code class="text-warning px-1 rounded bg-dark bg-opacity-25">contact_mobile[]</code>)</p>
        </div>
        <div class="card-body">
            <div class="row g-3">
                <div class="col-12 col-lg-4">
                    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                        <label class="form-label mb-0" id="label-contact-emails">อีเมล <span class="text-danger">*</span></label>
                        <button type="button" class="btn btn-sm btn-soft-primary" id="btn-add-contact-email">+ เพิ่มอีเมล</button>
                    </div>
                    <div id="contact-email-rows">
                        <div class="mb-2 contact-repeat-row">
                            <div class="input-group">
                                <input type="email" class="form-control" id="contact-email-1" name="contact_email[]" maxlength="255" required placeholder="name@example.com" autocomplete="email">
                                <button type="button" class="btn btn-outline-danger contact-row-remove" aria-label="ลบแถวอีเมล" disabled>ลบ</button>
                            </div>
                            <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-4">
                    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                        <label class="form-label mb-0" id="label-contact-phones">โทรศัพท์</label>
                        <button type="button" class="btn btn-sm btn-soft-primary" id="btn-add-contact-phone">+ เพิ่มเบอร์โทร</button>
                    </div>
                    <div id="contact-phone-rows">
                        <div class="input-group mb-2 contact-repeat-row flex-wrap">
                            <input type="tel" class="form-control mct-phone-landline" id="contact-phone-1" name="contact_phone[]" maxlength="11" inputmode="numeric" pattern="[0-9 ]*" placeholder="00 000 0000" autocomplete="tel" title="ตัวเลข 9 หลัก รูปแบบ 00 000 0000">
                            <span class="input-group-text px-2">#</span>
                            <input type="text" class="form-control mct-phone-ext" id="contact-phone-ext-1" name="contact_phone_ext[]" maxlength="6" inputmode="numeric" placeholder="ไม่บังคับ" style="max-width:6.5rem" title="เบอร์ต่อ (ตัวเลขเท่านั้น)" aria-label="เบอร์ต่อ">
                            <button type="button" class="btn btn-outline-danger contact-row-remove" aria-label="ลบแถวโทรศัพท์" disabled>ลบ</button>
                        </div>
                    </div>
                    <small class="text-muted d-block mt-1">เฉพาะตัวเลข · รูปแบบ 00 000 0000 · ถ้ามีเบอร์ต่อให้กรอกช่อง &quot;ต่อ&quot; — ไม่บังคับ</small>
                </div>
                <div class="col-12 col-lg-4">
                    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                        <label class="form-label mb-0" id="label-contact-mobiles">มือถือ <span class="text-danger">*</span></label>
                        <button type="button" class="btn btn-sm btn-soft-primary" id="btn-add-contact-mobile">+ เพิ่มเบอร์มือถือ</button>
                    </div>
                    <div id="contact-mobile-rows">
                        <div class="mb-2 contact-repeat-row">
                            <div class="input-group">
                                <input type="tel" class="form-control mct-phone-mobile" id="contact-mobile-1" name="contact_mobile[]" maxlength="12" required inputmode="numeric" pattern="[0-9 ]*" placeholder="000 000 0000" autocomplete="tel-national" title="มือถือไทย 10 หลัก ตัวเลขเท่านั้น">
                                <button type="button" class="btn btn-outline-danger contact-row-remove" aria-label="ลบแถวมือถือ" disabled>ลบ</button>
                            </div>
                            <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                        </div>
                    </div>
                    <small class="text-muted d-block mt-1">เฉพาะตัวเลข · รูปแบบ 000 000 0000 (10 หลัก)</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="contact-line-id">Line ID</label>
                    <input type="text" class="form-control" id="contact-line-id" name="line_id" maxlength="100" placeholder="Line ID หรือ @username">
                    <small class="form-text text-muted mb-0">ไม่บังคับ</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="contact-facebook">Facebook</label>
                    <input type="text" class="form-control" id="contact-facebook" name="facebook" maxlength="255" placeholder="ชื่อเพจหรือลิงก์">
                    <small class="form-text text-muted mb-0">ไม่บังคับ</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="contact-youtube">YouTube</label>
                    <input type="text" class="form-control" id="contact-youtube" name="youtube" maxlength="255" placeholder="ช่องหรือลิงก์ YouTube">
                    <small class="form-text text-muted mb-0">ไม่บังคับ</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="contact-tiktok">TikTok</label>
                    <input type="text" class="form-control" id="contact-tiktok" name="tiktok" maxlength="255" placeholder="@username หรือ URL">
                    <small class="form-text text-muted mb-0">ไม่บังคับ</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="contact-instagram">Instagram</label>
                    <input type="text" class="form-control" id="contact-instagram" name="instagram" maxlength="255" placeholder="@username หรือ URL">
                    <small class="form-text text-muted mb-0">ไม่บังคับ</small>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="form-label" for="contact-x-twitter">X (Twitter)</label>
                    <input type="text" class="form-control" id="contact-x-twitter" name="x_twitter" maxlength="255" placeholder="@username หรือ URL">
                    <small class="form-text text-muted mb-0">ไม่บังคับ</small>
                </div>
                <div class="col-lg-8">
                    <label class="form-label" for="contact-other">ช่องทางอื่น / หมายเหตุการติดต่อ</label>
                    <textarea class="form-control" id="contact-other" name="contact_note" rows="2" maxlength="500" placeholder="เช่น เวลาติดต่อได้ ช่องทางสำรอง"></textarea>
                    <small class="form-text text-muted mb-0">ไม่บังคับ</small>
                </div>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-header bg-primary text-white border-0">
            <h4 class="card-title mb-0 text-white">ที่อยู่</h4>
            <p class="small text-white-50 mb-0 mt-1">ที่อยู่ตามทะเบียน / ที่ส่งไปรษณีย์ (ที่อยู่ปัจจุบัน — ปรับปรุงภายหลังได้)</p>
        </div>
        <div class="card-body overflow-visible">
            <div class="row g-3 overflow-visible">
                <div class="col-12">
                    <label class="form-label" for="address-street">รายละเอียดที่อยู่ <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="address-street" name="address_street" maxlength="510" required autocomplete="street-address" placeholder="เลขที่ หมู่บ้าน อาคาร ห้อง / หมู่ที่ ซอย ถนน">
                    <input type="hidden" name="address_type" value="ที่อยู่ตามทะเบียน">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                    <small class="text-muted d-block">รวมข้อมูลเลขที่–อาคาร กับ หมู่ที่–ซอย–ถนนในช่องเดียว</small>
                </div>
                <div class="col-12">
                    <label class="form-label" for="address-live-search">ค้นหาที่อยู่จากฐานข้อมูล</label>
                    <div class="position-relative">
                        <input type="text" class="form-control" id="address-live-search" autocomplete="off" placeholder="พิมพ์ ตำบล อำเภอ จังหวัด หรือรหัสไปรษณีย์ (อย่างน้อย 2 ตัวอักษร)" aria-autocomplete="list" aria-controls="address-live-search-dropdown">
                        <div id="address-live-search-dropdown" class="list-group position-absolute w-100 mt-1 shadow-sm border rounded" role="listbox" style="z-index:1050;max-height:260px;overflow-y:auto;display:none;top:100%;left:0;"></div>
                    </div>
                    <div id="address-live-search-status" class="text-muted small mt-1"></div>
                    <div id="address-live-search-error" class="text-danger small mt-1" style="display:none;"></div>
                    <small class="text-muted d-block mt-1">ค้นหาแบบ Ajax จากฐาน <code>_db_admin_system</code> — เลือกรายการเพื่อกรอกตำบล อำเภอ จังหวัด และรหัสไปรษณีย์ด้านล่าง (ช่องเหล่านี้ <span class="text-danger fw-semibold">จำเป็นต้องกรอก</span> — ไม่ให้พิมพ์เอง ต้องเลือกจากรายการค้นหา)</small>
                </div>
                <div class="col-lg-3 col-md-6">
                    <label class="form-label" for="address-subdistrict">ตำบล / แขวง <span class="text-danger">*</span></label>
                    <input type="text" class="form-control bg-light" id="address-subdistrict" name="address_subdistrict" maxlength="120" required readonly placeholder="เลือกจากการค้นหาด้านบน" title="เลือกจากการค้นหาด้านบน">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-3 col-md-6">
                    <label class="form-label" for="address-district">อำเภอ / เขต <span class="text-danger">*</span></label>
                    <input type="text" class="form-control bg-light" id="address-district" name="address_district" maxlength="120" required readonly placeholder="เลือกจากการค้นหาด้านบน" title="เลือกจากการค้นหาด้านบน">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-3 col-md-6">
                    <label class="form-label" for="address-province">จังหวัด <span class="text-danger">*</span></label>
                    <input type="text" class="form-control bg-light" id="address-province" name="address_province" maxlength="120" required readonly placeholder="เลือกจากการค้นหาด้านบน" title="เลือกจากการค้นหาด้านบน">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
                <div class="col-lg-3 col-md-6">
                    <label class="form-label" for="address-postal-code">รหัสไปรษณีย์ <span class="text-danger">*</span></label>
                    <input type="text" class="form-control bg-light" id="address-postal-code" name="address_postal_code" maxlength="10" required inputmode="numeric" pattern="[0-9]{1,10}" placeholder="เลือกจากการค้นหาด้านบน (เช่น 10330)" readonly title="เลือกจากการค้นหาด้านบน">
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-body">
            <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center">
                <p class="text-muted small mb-0">ส่งฟอร์มไปที่ <code>actions/member/create-member.php</code> เพื่อบันทึกลงฐานข้อมูล — หลังบันทึกจะไปหน้ารายชื่อพร้อมข้อความแจ้งผล</p>
                <div class="d-flex flex-wrap gap-2 align-items-center">
                    <button v-if="showFormTestTools" type="button" class="btn btn-soft-warning btn-sm" id="btn-member-add-mock-fill-footer" title="เติมข้อมูลจำลองในฟอร์มเพื่อทดสอบ">เติมข้อมูลจำลอง (Test)</button>
                    <a :href="listUrl" class="btn btn-soft-secondary">ยกเลิก</a>
                    <button type="submit" class="btn btn-primary" id="btn-member-add-submit">บันทึกข้อมูล</button>
                </div>
            </div>
        </div>
    </div>
</form>
<div id="tpl-contact-email-row" hidden>
                <div class="mb-2 contact-repeat-row">
                    <div class="input-group">
                        <input type="email" class="form-control" name="contact_email[]" maxlength="255" required placeholder="name@example.com" autocomplete="email">
                        <button type="button" class="btn btn-outline-danger contact-row-remove" aria-label="ลบแถวอีเมล">ลบ</button>
                    </div>
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
            </div>
<div id="tpl-contact-phone-row" hidden>
                <div class="input-group mb-2 contact-repeat-row flex-wrap">
                    <input type="tel" class="form-control mct-phone-landline" name="contact_phone[]" maxlength="11" inputmode="numeric" pattern="[0-9 ]*" placeholder="00 000 0000" autocomplete="tel" title="ตัวเลข 9 หลัก รูปแบบ 00 000 0000">
                    <span class="input-group-text px-2">#</span>
                    <input type="text" class="form-control mct-phone-ext" name="contact_phone_ext[]" maxlength="6" inputmode="numeric" placeholder="ไม่บังคับ" style="max-width:6.5rem" title="เบอร์ต่อ (ตัวเลขเท่านั้น)" aria-label="เบอร์ต่อ">
                    <button type="button" class="btn btn-outline-danger contact-row-remove" aria-label="ลบแถวโทรศัพท์">ลบ</button>
                </div>
            </div>
<div id="tpl-contact-mobile-row" hidden>
                <div class="mb-2 contact-repeat-row">
                    <div class="input-group">
                        <input type="tel" class="form-control mct-phone-mobile" name="contact_mobile[]" maxlength="12" required inputmode="numeric" pattern="[0-9 ]*" placeholder="000 000 0000" autocomplete="tel-national" title="มือถือไทย 10 หลัก ตัวเลขเท่านั้น">
                        <button type="button" class="btn btn-outline-danger contact-row-remove" aria-label="ลบแถวมือถือ">ลบ</button>
                    </div>
                    <small class="form-text mb-0 text-danger fw-bold mct-req-hint d-none">จำเป็นต้องกรอก</small>
                </div>
            </div>
</div>
</template>

<script>
function runSuccessorAdd(config) {
    config = config || {};
    var presetRightsholderType = String(config.presetRightsholderType || "ทายาท");

    function mctFindControlForReqHint(hintEl) {
        if (hintEl.classList.contains("composer-affil-req-hint")) {
            return document.getElementById("composer-publisher-affiliation");
        }
        if (hintEl.classList.contains("mct-req-hint-legend")) {
            return null;
        }
        var prev = hintEl.previousElementSibling;
        if (prev) {
            if (prev.matches && (prev.matches("input") || prev.matches("select") || prev.matches("textarea"))) {
                return prev;
            }
            var inner = prev.querySelector && prev.querySelector("input:not([type='hidden']), select, textarea");
            if (inner) {
                return inner;
            }
        }
        var row = hintEl.closest(".contact-repeat-row");
        if (row) {
            return row.querySelector("input:not([type='hidden']), select, textarea");
        }
        return null;
    }

    function mctAddrDistrictColsEmpty() {
        var ids = ["address-subdistrict", "address-district", "address-province", "address-postal-code"];
        for (var ai = 0; ai < ids.length; ai++) {
            var el = document.getElementById(ids[ai]);
            if (!el || String(el.value || "").trim() === "") {
                return true;
            }
        }
        return false;
    }

    function mctShouldShowReqHint(hintEl, formEl) {
        if (hintEl.classList.contains("mct-req-hint-legend")) {
            try {
                if (formEl.querySelector(":invalid:not([disabled])")) {
                    return true;
                }
            } catch (e) {
                /* ignore */
            }
            return mctAddrDistrictColsEmpty();
        }
        var ctl = mctFindControlForReqHint(hintEl);
        if (!ctl || ctl.disabled) {
            return false;
        }
        if (hintEl.classList.contains("composer-affil-req-hint")) {
            var rhs = document.getElementById("rightsholder-type");
            if (!rhs || String(rhs.value || "") !== "นักแต่งเพลง") {
                return false;
            }
        }
        var cid = ctl.id || "";
        if (
            cid === "address-subdistrict" ||
            cid === "address-district" ||
            cid === "address-province" ||
            cid === "address-postal-code"
        ) {
            return String(ctl.value || "").trim() === "";
        }
        return !ctl.validity.valid;
    }

    function mctRefreshReqHints(formEl) {
        if (!formEl) {
            return;
        }
        if (!formEl.classList.contains("mct-submit-attempted")) {
            formEl.querySelectorAll(".mct-req-hint").forEach(function (h) {
                h.classList.add("d-none");
            });
            return;
        }
        formEl.querySelectorAll(".mct-req-hint").forEach(function (h) {
            if (mctShouldShowReqHint(h, formEl)) {
                h.classList.remove("d-none");
            } else {
                h.classList.add("d-none");
            }
        });
    }

    function setupContactRepeatable(containerId, templateId, addButtonId) {
        var container = document.getElementById(containerId);
        var template = document.getElementById(templateId);
        var addBtn = document.getElementById(addButtonId);
        if (!container || !template || !addBtn) {
            return;
        }

        function refreshRemoveButtons() {
            var rows = container.querySelectorAll(".contact-repeat-row");
            var multi = rows.length > 1;
            rows.forEach(function (row) {
                var rm = row.querySelector(".contact-row-remove");
                if (rm) {
                    rm.disabled = !multi;
                }
            });
        }

        addBtn.addEventListener("click", function () {
            var node = template.content
                ? template.content.cloneNode(true)
                : (template.firstElementChild ? template.firstElementChild.cloneNode(true) : null);
            if (!node) {
                return;
            }
            container.appendChild(node);
            refreshRemoveButtons();
            var fa = document.getElementById("form-member-add");
            if (fa && fa.classList.contains("mct-submit-attempted")) {
                mctRefreshReqHints(fa);
            }
        });

        container.addEventListener("click", function (e) {
            var btn = e.target && e.target.closest ? e.target.closest(".contact-row-remove") : null;
            if (!btn || !container.contains(btn)) {
                return;
            }
            var row = btn.closest(".contact-repeat-row");
            if (!row || container.querySelectorAll(".contact-repeat-row").length <= 1) {
                return;
            }
            row.remove();
            refreshRemoveButtons();
            var fb = document.getElementById("form-member-add");
            if (fb && fb.classList.contains("mct-submit-attempted")) {
                mctRefreshReqHints(fb);
            }
        });

        refreshRemoveButtons();
    }

    setupContactRepeatable("contact-email-rows", "tpl-contact-email-row", "btn-add-contact-email");
    setupContactRepeatable("contact-phone-rows", "tpl-contact-phone-row", "btn-add-contact-phone");
    setupContactRepeatable("contact-mobile-rows", "tpl-contact-mobile-row", "btn-add-contact-mobile");

    (function setupPhoneFormats() {
        function digitsOnly(str) {
            return String(str || "").replace(/\D/g, "");
        }

        function formatMobile(val) {
            var d = digitsOnly(val).slice(0, 10);
            var parts = [];
            if (d.length > 0) {
                parts.push(d.slice(0, 3));
            }
            if (d.length > 3) {
                parts.push(d.slice(3, 6));
            }
            if (d.length > 6) {
                parts.push(d.slice(6, 10));
            }
            return parts.join(" ");
        }

        function formatLandline(val) {
            var d = digitsOnly(val).slice(0, 9);
            var parts = [];
            if (d.length > 0) {
                parts.push(d.slice(0, 2));
            }
            if (d.length > 2) {
                parts.push(d.slice(2, 5));
            }
            if (d.length > 5) {
                parts.push(d.slice(5, 9));
            }
            return parts.join(" ");
        }

        function formatExt(val) {
            return digitsOnly(val).slice(0, 6);
        }

        var mobileRows = document.getElementById("contact-mobile-rows");
        if (mobileRows) {
            mobileRows.addEventListener("input", function (e) {
                var t = e.target;
                if (!t.classList || !t.classList.contains("mct-phone-mobile")) {
                    return;
                }
                var next = formatMobile(t.value);
                if (next !== t.value) {
                    t.value = next;
                }
            });
            mobileRows.addEventListener("paste", function (e) {
                var t = e.target;
                if (!t.classList || !t.classList.contains("mct-phone-mobile")) {
                    return;
                }
                e.preventDefault();
                var pasted = digitsOnly(e.clipboardData ? e.clipboardData.getData("text") : "");
                t.value = formatMobile(pasted);
            });
        }

        var phoneRows = document.getElementById("contact-phone-rows");
        if (phoneRows) {
            phoneRows.addEventListener("input", function (e) {
                var t = e.target;
                if (!t.classList) {
                    return;
                }
                if (t.classList.contains("mct-phone-landline")) {
                    var nl = formatLandline(t.value);
                    if (nl !== t.value) {
                        t.value = nl;
                    }
                }
                if (t.classList.contains("mct-phone-ext")) {
                    var nx = formatExt(t.value);
                    if (nx !== t.value) {
                        t.value = nx;
                    }
                }
            });
            phoneRows.addEventListener("paste", function (e) {
                var t = e.target;
                if (!t.classList) {
                    return;
                }
                if (t.classList.contains("mct-phone-landline")) {
                    e.preventDefault();
                    var pasted = digitsOnly(e.clipboardData ? e.clipboardData.getData("text") : "");
                    t.value = formatLandline(pasted);
                }
                if (t.classList.contains("mct-phone-ext")) {
                    e.preventDefault();
                    var pasted2 = digitsOnly(e.clipboardData ? e.clipboardData.getData("text") : "");
                    t.value = formatExt(pasted2);
                }
            });
        }
    })();

    (function setupComposerCreativeRoles() {
        var sel = document.getElementById("rightsholder-type");
        var wrap = document.getElementById("composer-creative-roles-wrap");
        var affiliationWrap = document.getElementById("composer-publisher-affiliation-wrap");
        var affiliationInput = document.getElementById("composer-publisher-affiliation");
        var affiliationLive = document.getElementById("affiliated-publisher-live-search");
        var affiliationMemberId = document.getElementById("affiliated-publisher-member-id");
        var affiliationDd = document.getElementById("affiliated-publisher-dropdown");
        var affiliationStatus = document.getElementById("affiliated-publisher-status");
        var affRequiredMark = document.querySelector("#composer-publisher-affiliation-wrap .composer-affil-req");
        var affRequiredHint = document.querySelector(".composer-affil-req-hint");
        if (!sel || !wrap) {
            return;
        }
        var boxes = wrap.querySelectorAll('input[type="checkbox"]');
        function sync() {
            var show = String(sel.value || "") === "นักแต่งเพลง";
            wrap.style.display = show ? "block" : "none";
            if (affiliationWrap) {
                affiliationWrap.style.display = show ? "block" : "none";
            }
            if (affiliationInput) {
                affiliationInput.disabled = !show;
                affiliationInput.required = !!show;
                if (!show) {
                    affiliationInput.value = "";
                }
            }
            if (affRequiredMark) {
                affRequiredMark.classList.toggle("d-none", !show);
            }
            if (affRequiredHint) {
                affRequiredHint.classList.add("d-none");
            }
            if (affiliationLive) {
                affiliationLive.disabled = !show;
                if (!show) {
                    affiliationLive.value = "";
                }
            }
            if (affiliationMemberId) {
                affiliationMemberId.disabled = !show;
                if (!show) {
                    affiliationMemberId.value = "";
                }
            }
            if (!show && affiliationDd) {
                affiliationDd.style.display = "none";
                affiliationDd.innerHTML = "";
            }
            if (!show && affiliationStatus) {
                affiliationStatus.textContent = "";
            }
            if (!show) {
                boxes.forEach(function (cb) {
                    cb.checked = false;
                });
            }
            var fComposer = document.getElementById("form-member-add");
            if (fComposer && fComposer.classList.contains("mct-submit-attempted")) {
                mctRefreshReqHints(fComposer);
            }
        }
        sel.addEventListener("change", sync);
        sync();
    })();

    (function applyPresetRightsholderType() {
        var sel = document.getElementById("rightsholder-type");
        if (!sel) {
            return;
        }
        var wanted = String(presetRightsholderType || "").trim();
        if (!wanted) {
            return;
        }
        var hasOption = false;
        for (var i = 0; i < sel.options.length; i++) {
            if (String(sel.options[i].value || "") === wanted) {
                hasOption = true;
                break;
            }
        }
        if (!hasOption) {
            return;
        }
        sel.value = wanted;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
    })();

    (function setupPersonalVsPublisherOrg() {
        var sel = document.getElementById("rightsholder-type");
        var personWrap = document.getElementById("personal-info-person-wrap");
        var orgWrap = document.getElementById("personal-info-org-wrap");
        var hPerson = document.getElementById("personal-card-heading-person");
        var hOrg = document.getElementById("personal-card-heading-org");
        var dPerson = document.getElementById("personal-card-desc-person");
        var dOrg = document.getElementById("personal-card-desc-org");
        if (!sel || !personWrap || !orgWrap) {
            return;
        }

        var PUBLISHER = "บริษัทผู้พิมพ์ผู้โฆษณา(Publisher)";

        function setDisabled(container, disabled) {
            container.querySelectorAll("input, select, textarea").forEach(function (el) {
                el.disabled = !!disabled;
            });
        }

        function sync() {
            var isPublisher = String(sel.value || "") === PUBLISHER;
            if (isPublisher) {
                personWrap.classList.add("d-none");
                orgWrap.classList.remove("d-none");
                setDisabled(personWrap, true);
                setDisabled(orgWrap, false);
                if (hPerson) {
                    hPerson.classList.add("d-none");
                }
                if (hOrg) {
                    hOrg.classList.remove("d-none");
                }
                if (dPerson) {
                    dPerson.classList.add("d-none");
                }
                if (dOrg) {
                    dOrg.classList.remove("d-none");
                }
            } else {
                personWrap.classList.remove("d-none");
                orgWrap.classList.add("d-none");
                setDisabled(personWrap, false);
                setDisabled(orgWrap, true);
                if (hPerson) {
                    hPerson.classList.remove("d-none");
                }
                if (hOrg) {
                    hOrg.classList.add("d-none");
                }
                if (dPerson) {
                    dPerson.classList.remove("d-none");
                }
                if (dOrg) {
                    dOrg.classList.add("d-none");
                }
            }
            var fOrgSwitch = document.getElementById("form-member-add");
            if (fOrgSwitch && fOrgSwitch.classList.contains("mct-submit-attempted")) {
                mctRefreshReqHints(fOrgSwitch);
            }
        }

        sel.addEventListener("change", sync);
        sync();
    })();

    /* ใช้ URL จากหน้าปัจจุบัน — แก้ปัญหา SCRIPT_NAME ไม่มีโฟลเดอร์ย่อยทำให้เรียก API ผิดพาธ */
    var addressSearchUrl = String(config.addressSearchUrl || new URL("actions/thailand-address-search.php", window.location.href).href);
    var addrInput = document.getElementById("address-live-search");
    var addrDd = document.getElementById("address-live-search-dropdown");
    var addrStatus = document.getElementById("address-live-search-status");
    var addrErr = document.getElementById("address-live-search-error");
    var fldSub = document.getElementById("address-subdistrict");
    var fldDist = document.getElementById("address-district");
    var fldProv = document.getElementById("address-province");
    var fldZip = document.getElementById("address-postal-code");

    function escapeHtml(str) {
        var d = document.createElement("div");
        d.textContent = str == null ? "" : String(str);
        return d.innerHTML;
    }

    (function setupPublisherAffiliationLiveSearch() {
        var pubUrl = String(config.publisherSearchUrl || new URL("actions/publisher-affiliation-search.php", window.location.href).href);
        var liveInput = document.getElementById("affiliated-publisher-live-search");
        var dd = document.getElementById("affiliated-publisher-dropdown");
        var statusEl = document.getElementById("affiliated-publisher-status");
        var affiliationField = document.getElementById("composer-publisher-affiliation");
        var memberIdField = document.getElementById("affiliated-publisher-member-id");
        if (!liveInput || !dd || !affiliationField) {
            return;
        }

        var timer = null;
        var abortCtl = null;

        function hidePubDd() {
            dd.style.display = "none";
            dd.innerHTML = "";
        }

        function setPubStatus(t) {
            if (statusEl) {
                statusEl.textContent = t || "";
            }
        }

        liveInput.addEventListener("input", function () {
            setPubStatus("");
            var q = String(liveInput.value || "").trim();
            hidePubDd();
            if (timer) {
                clearTimeout(timer);
            }
            if (abortCtl) {
                abortCtl.abort();
                abortCtl = null;
            }
            if (memberIdField) {
                memberIdField.value = "";
            }
            if (q.length < 2) {
                return;
            }
            timer = setTimeout(function () {
                timer = null;
                if (abortCtl) {
                    abortCtl.abort();
                }
                abortCtl = new AbortController();
                setPubStatus("กำลังค้นหา...");
                fetch(pubUrl + "?q=" + encodeURIComponent(q) + "&limit=25", {
                    signal: abortCtl.signal,
                    credentials: "same-origin",
                })
                    .then(function (res) {
                        return res.text().then(function (text) {
                            var data = null;
                            try {
                                data = text ? JSON.parse(text) : null;
                            } catch (ignore) {
                                data = null;
                            }
                            return { ok: res.ok, status: res.status, data: data };
                        });
                    })
                    .then(function (pack) {
                        setPubStatus("");
                        if (!pack.data || !pack.data.success) {
                            hidePubDd();
                            return;
                        }
                        var rows = pack.data.results || [];
                        var meta = pack.data.meta || {};
                        if (rows.length === 0) {
                            dd.innerHTML = '<span class="list-group-item text-muted">ไม่พบ Publisher ในฐานข้อมูล</span>';
                            dd.style.display = "block";
                            return;
                        }
                        var html = "";
                        rows.forEach(function (r, idx) {
                            var line = escapeHtml(r.line || r.label || "");
                            html +=
                                '<button type="button" class="list-group-item list-group-item-action text-start" role="option" data-idx="' +
                                idx +
                                '">' +
                                line +
                                "</button>";
                        });
                        dd.innerHTML = html;
                        dd.__rows = rows;
                        dd.style.display = "block";
                        if (meta.table) {
                            setPubStatus("ค้นจาก " + meta.table + " · " + rows.length + " รายการ");
                        }
                    })
                    .catch(function (e) {
                        if (e && e.name === "AbortError") {
                            return;
                        }
                        setPubStatus("");
                        hidePubDd();
                    });
            }, 280);
        });

        dd.addEventListener("click", function (e) {
            var btn = e.target && e.target.closest ? e.target.closest("button[data-idx]") : null;
            if (!btn || !dd.contains(btn)) {
                return;
            }
            var idx = parseInt(btn.getAttribute("data-idx"), 10);
            var rows = dd.__rows;
            if (!rows || !rows[idx]) {
                return;
            }
            var r = rows[idx];
            affiliationField.value = r.label || "";
            if (memberIdField) {
                memberIdField.value = r.member_id ? String(r.member_id) : "";
            }
            hidePubDd();
            liveInput.value = "";
            setPubStatus("");
        });

        affiliationField.addEventListener("input", function () {
            if (memberIdField) {
                memberIdField.value = "";
            }
        });

        document.addEventListener("click", function (e) {
            var t = e.target;
            if (liveInput.contains(t) || dd.contains(t)) {
                return;
            }
            hidePubDd();
        });
    })();

    function hideAddrDropdown() {
        if (addrDd) {
            addrDd.style.display = "none";
            addrDd.innerHTML = "";
        }
    }

    function setAddrError(msg) {
        if (!addrErr) {
            return;
        }
        if (msg) {
            addrErr.style.display = "block";
            addrErr.textContent = msg;
        } else {
            addrErr.style.display = "none";
            addrErr.textContent = "";
        }
    }

    if (addrInput && addrDd && fldSub && fldDist && fldProv && fldZip) {
        var addrTimer = null;
        var addrAbort = null;

        addrInput.addEventListener("input", function () {
            setAddrError("");
            if (addrStatus) {
                addrStatus.textContent = "";
            }
            var q = String(addrInput.value || "").trim();
            hideAddrDropdown();
            if (addrTimer) {
                clearTimeout(addrTimer);
            }
            if (addrAbort) {
                addrAbort.abort();
                addrAbort = null;
            }
            if (q.length < 2) {
                return;
            }
            addrTimer = setTimeout(function () {
                addrTimer = null;
                if (addrAbort) {
                    addrAbort.abort();
                }
                addrAbort = new AbortController();
                var u = addressSearchUrl + "?q=" + encodeURIComponent(q) + "&limit=25";
                if (addrStatus) {
                    addrStatus.textContent = "กำลังค้นหา...";
                }
                fetch(u, { signal: addrAbort.signal, credentials: "same-origin" })
                    .then(function (res) {
                        return res.text().then(function (text) {
                            var data = null;
                            try {
                                data = text ? JSON.parse(text) : null;
                            } catch (ignore) {
                                data = null;
                            }
                            return { ok: res.ok, status: res.status, raw: text, data: data };
                        });
                    })
                    .then(function (pack) {
                        if (addrStatus) {
                            addrStatus.textContent = "";
                        }
                        if (!pack.data) {
                            setAddrError(
                                "ได้รับคำตอบไม่ใช่ JSON (HTTP " +
                                    pack.status +
                                    ") — ตรวจสอบ URL หรือ session หมดอายุ"
                            );
                            hideAddrDropdown();
                            return;
                        }
                        if (!pack.ok || !pack.data.success) {
                            var m =
                                pack.data && pack.data.message
                                    ? pack.data.message
                                    : "ค้นหาไม่สำเร็จ (HTTP " + pack.status + ")";
                            setAddrError(m);
                            hideAddrDropdown();
                            return;
                        }
                        var rows = pack.data.results || [];
                        var meta = pack.data.meta || {};
                        if (addrStatus && meta.table) {
                            addrStatus.textContent = "ค้นจากตาราง " + meta.table + (rows.length ? " · พบ " + rows.length + " รายการ" : "");
                        }
                        if (rows.length === 0) {
                            addrDd.innerHTML =
                                '<span class="list-group-item text-muted">ไม่พบข้อมูล</span>';
                            addrDd.style.display = "block";
                            return;
                        }
                        var html = "";
                        rows.forEach(function (r, idx) {
                            var line =
                                escapeHtml(r.subdistrict || "") +
                                " » " +
                                escapeHtml(r.district || "") +
                                " » " +
                                escapeHtml(r.province || "") +
                                " " +
                                escapeHtml(r.postal_code || "");
                            html +=
                                '<button type="button" class="list-group-item list-group-item-action text-start" role="option" data-idx="' +
                                idx +
                                '">' +
                                line +
                                "</button>";
                        });
                        addrDd.innerHTML = html;
                        addrDd.__rows = rows;
                        addrDd.style.display = "block";
                    })
                    .catch(function (e) {
                        if (e && e.name === "AbortError") {
                            return;
                        }
                        if (addrStatus) {
                            addrStatus.textContent = "";
                        }
                        setAddrError("เชื่อมต่อเซิร์ฟเวอร์ไม่ได้");
                        hideAddrDropdown();
                    });
            }, 320);
        });

        addrDd.addEventListener("click", function (e) {
            var btn = e.target && e.target.closest ? e.target.closest("button[data-idx]") : null;
            if (!btn || !addrDd.contains(btn)) {
                return;
            }
            var idx = parseInt(btn.getAttribute("data-idx"), 10);
            var rows = addrDd.__rows;
            if (!rows || !rows[idx]) {
                return;
            }
            var r = rows[idx];
            fldSub.value = r.subdistrict || "";
            fldDist.value = r.district || "";
            fldProv.value = r.province || "";
            fldZip.value = r.postal_code || "";
            hideAddrDropdown();
            addrInput.value = "";
            setAddrError("");
            var fAddrPick = document.getElementById("form-member-add");
            if (fAddrPick && fAddrPick.classList.contains("mct-submit-attempted")) {
                mctRefreshReqHints(fAddrPick);
            }
        });

        document.addEventListener("click", function (e) {
            if (!addrInput || !addrDd) {
                return;
            }
            var t = e.target;
            if (addrInput.contains(t) || addrDd.contains(t)) {
                return;
            }
            hideAddrDropdown();
        });
    }

    function mctDigitsFormatMobile(raw) {
        var d = String(raw || "").replace(/\D/g, "").slice(0, 10);
        var parts = [];
        if (d.length > 0) {
            parts.push(d.slice(0, 3));
        }
        if (d.length > 3) {
            parts.push(d.slice(3, 6));
        }
        if (d.length > 6) {
            parts.push(d.slice(6, 10));
        }
        return parts.join(" ");
    }

    function mctDigitsFormatLandline(raw) {
        var d = String(raw || "").replace(/\D/g, "").slice(0, 9);
        var parts = [];
        if (d.length > 0) {
            parts.push(d.slice(0, 2));
        }
        if (d.length > 2) {
            parts.push(d.slice(2, 5));
        }
        if (d.length > 5) {
            parts.push(d.slice(5, 9));
        }
        return parts.join(" ");
    }

    function mctFillMemberAddMockData() {
        var ts = Date.now();
        var suf = String(ts).slice(-8);

        var internal = document.getElementById("internal-no-mis");
        if (internal) {
            internal.value = ("000000" + String(ts % 1000000)).slice(-6);
        }
        var ipiName = document.getElementById("ipi-name-no");
        if (ipiName) {
            var nameDigits = ("00000000000" + String(ts % 100000000000)).slice(-11);
            ipiName.value = nameDigits;
        }
        var ipiBase = document.getElementById("ipi-base-no");
        if (ipiBase) {
            var baseMid = ("000000000" + String(ts % 1000000000)).slice(-9);
            ipiBase.value = "I-" + baseMid + "-2";
        }

        var writerType = document.getElementById("writer-type");
        if (writerType) {
            writerType.value = "General Member";
        }

        var rhs = document.getElementById("rightsholder-type");
        if (rhs) {
            rhs.value = "นักแต่งเพลง";
            rhs.dispatchEvent(new Event("change", { bubbles: true }));
        }

        var cm = document.getElementById("creative-role-melody");
        var cl = document.getElementById("creative-role-lyrics");
        var ca = document.getElementById("creative-role-arrangement");
        if (cm) {
            cm.checked = true;
        }
        if (cl) {
            cl.checked = true;
        }
        if (ca) {
            ca.checked = true;
        }

        var aff = document.getElementById("composer-publisher-affiliation");
        if (aff) {
            aff.value = "ค่ายทดสอบ MCT (Mock Publisher)";
        }
        var affMid = document.getElementById("affiliated-publisher-member-id");
        if (affMid) {
            affMid.value = "";
        }
        var affLive = document.getElementById("affiliated-publisher-live-search");
        if (affLive) {
            affLive.value = "";
        }

        var titleEl = document.getElementById("title");
        if (titleEl) {
            titleEl.value = "นาย";
        }
        var fnl = document.getElementById("first-name-local");
        if (fnl) {
            fnl.value = "ทดสอบ";
        }
        var lnl = document.getElementById("last-name-local");
        if (lnl) {
            lnl.value = "ระบบสมาชิก";
        }
        var fne = document.getElementById("first-name-eng");
        if (fne) {
            fne.value = "Test";
        }
        var lne = document.getElementById("last-name-eng");
        if (lne) {
            lne.value = "MemberMock";
        }
        var idc = document.getElementById("id-card-number");
        if (idc) {
            idc.value = "1-2345-67890-12-3";
        }
        var bd = document.getElementById("birth-date");
        if (bd) {
            bd.value = "1990-06-15";
        }
        var nat = document.getElementById("nationality");
        if (nat) {
            nat.value = "ไทย";
        }

        var addEmail = document.getElementById("btn-add-contact-email");
        if (addEmail) {
            addEmail.click();
        }
        var emails = document.querySelectorAll('#contact-email-rows input[name="contact_email[]"]');
        if (emails[0]) {
            emails[0].value = "test.mock.primary." + suf + "@example.com";
        }
        if (emails[1]) {
            emails[1].value = "test.mock.backup." + suf + "@example.com";
        }

        var addPhone = document.getElementById("btn-add-contact-phone");
        if (addPhone) {
            addPhone.click();
        }
        var phones = document.querySelectorAll('#contact-phone-rows input[name="contact_phone[]"]');
        var phoneExts = document.querySelectorAll('#contact-phone-rows input[name="contact_phone_ext[]"]');
        if (phones[0]) {
            phones[0].value = mctDigitsFormatLandline("021234567");
            phones[0].dispatchEvent(new Event("input", { bubbles: true }));
        }
        if (phoneExts[0]) {
            phoneExts[0].value = "101";
            phoneExts[0].dispatchEvent(new Event("input", { bubbles: true }));
        }
        if (phones[1]) {
            phones[1].value = mctDigitsFormatLandline("038765432");
            phones[1].dispatchEvent(new Event("input", { bubbles: true }));
        }
        if (phoneExts[1]) {
            phoneExts[1].value = "402";
            phoneExts[1].dispatchEvent(new Event("input", { bubbles: true }));
        }

        var addMob = document.getElementById("btn-add-contact-mobile");
        if (addMob) {
            addMob.click();
        }
        var mobs = document.querySelectorAll('#contact-mobile-rows input[name="contact_mobile[]"]');
        if (mobs[0]) {
            mobs[0].value = mctDigitsFormatMobile("0812345678");
            mobs[0].dispatchEvent(new Event("input", { bubbles: true }));
        }
        if (mobs[1]) {
            mobs[1].value = mctDigitsFormatMobile("0898765432");
            mobs[1].dispatchEvent(new Event("input", { bubbles: true }));
        }

        var lineId = document.getElementById("contact-line-id");
        if (lineId) {
            lineId.value = "@mct_mock_test";
        }
        var fb = document.getElementById("contact-facebook");
        if (fb) {
            fb.value = "facebook.com/mct.mock.test";
        }
        var yt = document.getElementById("contact-youtube");
        if (yt) {
            yt.value = "youtube.com/@mct.mock.test";
        }
        var tt = document.getElementById("contact-tiktok");
        if (tt) {
            tt.value = "@mct_mock_test";
        }
        var ig = document.getElementById("contact-instagram");
        if (ig) {
            ig.value = "@mct_mock_test";
        }
        var x = document.getElementById("contact-x-twitter");
        if (x) {
            x.value = "@mct_mock_test";
        }
        var note = document.getElementById("contact-other");
        if (note) {
            note.value = "ข้อมูลจำลองสำหรับทดสอบฟอร์ม — " + new Date().toISOString();
        }

        var street = document.getElementById("address-street");
        if (street) {
            street.value = "99/1 อาคารจำลอง ชั้น 4 ถนนทดสอบ แขวงตัวอย่าง";
        }
        var sub = document.getElementById("address-subdistrict");
        if (sub) {
            sub.value = "แขวงทดสอบ";
        }
        var dist = document.getElementById("address-district");
        if (dist) {
            dist.value = "เขตทดสอบ";
        }
        var prov = document.getElementById("address-province");
        if (prov) {
            prov.value = "กรุงเทพมหานคร";
        }
        var zip = document.getElementById("address-postal-code");
        if (zip) {
            zip.value = "10330";
        }

        var addrSearch = document.getElementById("address-live-search");
        if (addrSearch) {
            addrSearch.value = "";
        }

        var alertTop = document.getElementById("member-add-alert");
        if (alertTop) {
            alertTop.innerHTML =
                '<div class="alert alert-success alert-dismissible fade show" role="alert">' +
                "<strong>เติมข้อมูลจำลองแล้ว</strong> — ตรวจสอบแล้วกดบันทึกเพื่อส่งไปบันทึกในฐานข้อมูล" +
                '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
                "</div>";
            alertTop.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    function mctBindDigitsOnly(el) {
        if (!el) {
            return;
        }
        el.addEventListener("input", function () {
            var v = String(el.value || "").replace(/\D/g, "");
            if (el.value !== v) {
                el.value = v;
            }
        });
        el.addEventListener("blur", function () {
            el.value = String(el.value || "").replace(/\D/g, "");
        });
    }
    mctBindDigitsOnly(document.getElementById("internal-no-mis"));
    mctBindDigitsOnly(document.getElementById("ipi-name-no"));

    function mctDigitsToThaiIdFormatted(raw) {
        var digits = String(raw || "").replace(/\D/g, "").slice(0, 13);
        var p1 = digits.slice(0, 1);
        var p2 = digits.slice(1, 5);
        var p3 = digits.slice(5, 10);
        var p4 = digits.slice(10, 12);
        var p5 = digits.slice(12, 13);
        var parts = [p1, p2, p3, p4, p5].filter(function (x) { return x !== ""; });
        return parts.join("-");
    }
    function mctBindThaiIdFormat(el) {
        if (!el) {
            return;
        }
        el.addEventListener("input", function () {
            el.value = mctDigitsToThaiIdFormatted(el.value);
        });
        el.addEventListener("blur", function () {
            el.value = mctDigitsToThaiIdFormatted(el.value);
        });
    }
    mctBindThaiIdFormat(document.getElementById("id-card-number"));

    var btnMock = document.getElementById("btn-member-add-mock-fill");
    var btnMockFoot = document.getElementById("btn-member-add-mock-fill-footer");
    if (btnMock) {
        btnMock.addEventListener("click", mctFillMemberAddMockData);
    }
    if (btnMockFoot) {
        btnMockFoot.addEventListener("click", mctFillMemberAddMockData);
    }

    var form = document.getElementById("form-member-add");
    var alertBox = document.getElementById("member-add-alert");
    if (!form) {
        return;
    }

    var MCT_FORBIDDEN_THANG_MOD = "ทั้งหมด";
    var MCT_ALLOW_THANG_MOD_NAMES = {
        "contact_phone[]": true,
        "contact_phone_ext[]": true,
        "contact_mobile[]": true,
        line_id: true,
        contact_note: true
    };

    function mctClearCustomValidity(formEl) {
        var all = formEl.querySelectorAll("input, textarea, select");
        for (var i = 0; i < all.length; i++) {
            if (all[i].setCustomValidity) {
                all[i].setCustomValidity("");
            }
        }
    }

    function mctValidateNoThangMod(formEl) {
        var els = formEl.elements;
        for (var i = 0; i < els.length; i++) {
            var el = els[i];
            var nm = el.name || "";
            if (!nm || MCT_ALLOW_THANG_MOD_NAMES[nm]) {
                continue;
            }
            var typ = (el.type || "").toLowerCase();
            if (typ === "hidden" || typ === "button" || typ === "submit" || typ === "checkbox" || typ === "radio") {
                continue;
            }
            if (typ === "file") {
                continue;
            }
            var tag = el.tagName.toLowerCase();
            if (tag !== "input" && tag !== "textarea" && tag !== "select") {
                continue;
            }
            var raw = typeof el.value === "string" ? el.value : "";
            if (raw.trim() === MCT_FORBIDDEN_THANG_MOD) {
                if (el.setCustomValidity) {
                    el.setCustomValidity('ไม่สามารถใช้คำว่า «ทั้งหมด» ในช่องนี้ได้');
                }
                el.reportValidity();
                el.focus();
                return false;
            }
        }
        return true;
    }

    form.addEventListener("input", function (ev) {
        var trg = ev.target;
        if (trg && trg.setCustomValidity) {
            trg.setCustomValidity("");
        }
        if (form.classList.contains("mct-submit-attempted")) {
            mctRefreshReqHints(form);
        }
    });
    form.addEventListener("change", function () {
        if (form.classList.contains("mct-submit-attempted")) {
            mctRefreshReqHints(form);
        }
    });

    form.addEventListener("submit", function (e) {
        mctClearCustomValidity(form);
        if (!mctValidateNoThangMod(form)) {
            e.preventDefault();
            form.classList.add("mct-submit-attempted");
            mctRefreshReqHints(form);
            return;
        }
        if (!form.checkValidity()) {
            e.preventDefault();
            form.classList.add("mct-submit-attempted");
            mctRefreshReqHints(form);
            form.reportValidity();
            return;
        }
        /* ช่องตำบล–รหัสไปรษณีย์เป็น readonly — ไม่เข้า HTML constraint validation ต้องตรวจเอง */
        if (mctAddrDistrictColsEmpty()) {
            e.preventDefault();
            form.classList.add("mct-submit-attempted");
            mctRefreshReqHints(form);
            var addrLive = document.getElementById("address-live-search");
            if (addrLive) {
                addrLive.focus();
            }
            return;
        }
        form.classList.remove("mct-submit-attempted");
        /* ผ่าน validation แล้วให้ส่งตาม action (actions/member/create-member.php) */
    });
}

export default {
  name: "SuccessorAdd",
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    autoMemberCode: function () {
      return String((this.config && this.config.autoMemberCode) || "");
    },
    createUrl: function () {
      return String((this.config && this.config.createUrl) || "actions/member/create-member.php");
    },
    listUrl: function () {
      return String((this.config && this.config.listUrl) || "main-manage-member.php?page=successor_list_all");
    },
    sourceMemberCode: function () {
      return String((this.config && this.config.sourceMemberCode) || "");
    },
    sourceMemberName: function () {
      return String((this.config && this.config.sourceMemberName) || "");
    },
    sourceWriterType: function () {
      return String((this.config && this.config.sourceWriterType) || "");
    },
    showFormTestTools: function () {
      return !!(this.config && this.config.showFormTestTools);
    },
    flashMessage: function () {
      var flash = this.config && this.config.flash;
      return flash && flash.message ? String(flash.message) : "";
    },
    flashKind: function () {
      var flash = this.config && this.config.flash;
      return flash && flash.kind === "success" ? "success" : "danger";
    },
  },
  mounted: function () {
    runSuccessorAdd(this.config || {});
  },
};
</script>
